import axios, { AxiosInstance } from "axios";
import * as g from "./generated";

export class ApiClients {
  private _instance: AxiosInstance;
  private _baseUrl: string;
  private _token: string = "";

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this._baseUrl = baseUrl ?? process.env.REACT_APP_BACKEND_URL ?? "http://localhost:3009";
    this._instance = instance ?? axios.create();
    this.token = "";
  }

  get axiosInstance(): AxiosInstance {
    return this._instance;
  }

  get token(): string {
    return this._token;
  }
  set token(token: string) {
    this._token = token;
    if (token) {
      this._instance.defaults.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete this._instance.defaults.headers["Authorization"];
    }
  }

  private _auth: g.AuthControllerClient | undefined;
  get auth(): g.AuthControllerClient {
    return this._auth || (this._auth = new g.AuthControllerClient(this._baseUrl, this._instance));
  }

  private _common: g.CommonControllerClient | undefined;
  get common(): g.CommonControllerClient {
    return this._common || (this._common = new g.CommonControllerClient(this._baseUrl, this._instance));
  }

  private _user: g.UserControllerClient | undefined;
  get user(): g.UserControllerClient {
    return this._user || (this._user = new g.UserControllerClient(this._baseUrl, this._instance));
  }

  private _systemLog: g.SystemLogControllerClient | undefined;
  get systemLog(): g.SystemLogControllerClient {
    return this._systemLog || (this._systemLog = new g.SystemLogControllerClient(this._baseUrl, this._instance));
  }

  private _file: g.FileControllerClient | undefined;
  get file(): g.FileControllerClient {
    return this._file || (this._file = new g.FileControllerClient(this._baseUrl, this._instance));
  }

  private _product: g.ProductControllerClient | undefined;
  get product(): g.ProductControllerClient {
    return this._product || (this._product = new g.ProductControllerClient(this._baseUrl, this._instance));
  }

  private _retailer: g.RetailerControllerClient | undefined;
  get retailer(): g.RetailerControllerClient {
    return this._retailer || (this._retailer = new g.RetailerControllerClient(this._baseUrl, this._instance));
  }

  private _retailerProduct: g.RetailerProductControllerClient | undefined;
  get retailerProduct(): g.RetailerProductControllerClient {
    return this._retailerProduct || (this._retailerProduct = new g.RetailerProductControllerClient(this._baseUrl, this._instance));
  }

  private _retailerVendor: g.RetailerVendorControllerClient | undefined;
  get retailerVendor(): g.RetailerVendorControllerClient {
    return this._retailerVendor || (this._retailerVendor = new g.RetailerVendorControllerClient(this._baseUrl, this._instance));
  }

  private _systemSettings: g.SystemSettingsControllerClient | undefined;
  get systemSettings(): g.SystemSettingsControllerClient {
    return this._systemSettings || (this._systemSettings = new g.SystemSettingsControllerClient(this._baseUrl, this._instance));
  }

  private _vendor: g.VendorControllerClient | undefined;
  get vendor(): g.VendorControllerClient {
    return this._vendor || (this._vendor = new g.VendorControllerClient(this._baseUrl, this._instance));
  }

  private _scheduler: g.SchedulerControllerClient | undefined;
  get scheduler(): g.SchedulerControllerClient {
    return this._scheduler || (this._scheduler = new g.SchedulerControllerClient(this._baseUrl, this._instance));
  }
}

const api: ApiClients = new ApiClients();

export default api;
export * from "./generated";
